import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { Artefacts } from "@kursk/components/pages/Artefacts/Artefacts";
import { loadEntitiesFromQuery } from "@kursk/utils/loadEntitiesFromQuery";

export default function PlacesPage() {

  return <Artefacts/>;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query }) => {

  await Promise.all([
    loadEntitiesFromQuery('artefacts', query, store),
  ]);

  return { props: {} };
})
